import { initProductionSentry } from './lib/sentry-production'
import { initPostHog, isPostHogEnabled, posthog } from './lib/posthog'
import ReactDOM from 'react-dom/client'
import { Suspense } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { PostHogProvider } from 'posthog-js/react'
import { App } from './app'
import { SideNavExpandedProvider } from './contexts/side-nav-expanded-context'
import { IntercomProvider } from 'react-use-intercom'
import { PostHogPageviewTracker } from './components/PostHogPageviewTracker'
import { setIntercomUnreadCount } from './hooks/use-intercom-messenger'
import { installStaleChunkReload } from './lib/reloadOnStaleChunk'

const INTERCOM_APP_ID = 'cj1tshpx'

initProductionSentry()
initPostHog()
installStaleChunkReload()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

const appTree = (
  <HelmetProvider>
    <IntercomProvider
      appId={INTERCOM_APP_ID}
      onUnreadCountChange={setIntercomUnreadCount}
    >
      <BrowserRouter>
        <PostHogPageviewTracker />
        <SideNavExpandedProvider>
          <Suspense>
            <App />
          </Suspense>
        </SideNavExpandedProvider>
      </BrowserRouter>
    </IntercomProvider>
  </HelmetProvider>
)

root.render(
  isPostHogEnabled() ? (
    <PostHogProvider client={posthog}>{appTree}</PostHogProvider>
  ) : (
    appTree
  ),
)
